export default __webpack_public_path__ + "static/media/Resume_08Aug2021.8553c74f.pdf";